import type { OverWritable } from '../../@types/settings';

export const paper: OverWritable = {
  MuiPaper: {
    defaultProps: {
      elevation: 0,
    },

    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
    },
  },
};
